(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();

    /*
      const targetNode = document.getElementById('Details-menu-drawer-container');
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
       
      });
    });
    
    observer.observe(targetNode, { attributes: true });
  */
      
  // 创建 MutationObserver 实例
        this.mutationObserver = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
              //megaMenu
              
                if (mutation.target.classList.contains("mega-menu") && mutation.type === 'attributes' && mutation.attributeName === 'open') {
                    var isAnyOpen =this.isAnyMenuOpen();
                    const isOpen = mutation.target.hasAttribute('open');
                    console.log('Menu is open?' + (isOpen ? 'open' : 'closed'));
                  console.log('Menu is anyopen?' + (isOpen ? 'open' : 'closed'));
                  console.log(mutation.target);
                    if(!isAnyOpen){
                      console.log('Menu is anyopen?' + (isOpen ? 'open' : 'closed'));
              
                         isAnyOpen =this.isAnyMenuOpen();
                         this.checkMenuOpenAndRemoveClass(isAnyOpen);     
             
                      
                    }else{
                        this.checkMenuOpenAndRemoveClass(isAnyOpen);  
                    }

                }

              //drawer
              /*
               if (mutation.attributeName === 'class') {
                    console.log('drawer Class attribute changed:', mutation.target.className);
                 if(mutation.target.className === 'menu-drawer-container'){
                   
                   console.log( mutation.target.hasAttribute('open'));
                   if(mutation.target.hasAttribute('open')){
                     console.log( 'drawer异常打开..');
                   }
                   
                 }
                }
              */

              
            });
        });
    }
    

    connectedCallback() {
       
      console.debug('begin...')
      // this.setupMenuObservation();

      
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
   
        
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

        // 选择你的headermenu项
    const menuItems = document.querySelectorAll('.list-menu > li');
      var h = this.header;
   console.debug('this.header1:'+h);
   
      const mutationObserver=this.mutationObserver;
      
      var th = this;

     const megaMenus = document.querySelectorAll('.mega-menu');
     //const menuDrawerC = document.getElementById('Details-menu-drawer-container');
        megaMenus.forEach(menu => {
            mutationObserver.observe(menu, { attributes: true });
        });
      //mutationObserver.observe(menuDrawerC, { attributes: true });
      
      /*
    menuItems.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
          console.debug('menuitem mouseenter');
          const hasOpen =  th.isAnyMenuOpen();
          console.debug('hasOpen?????');
          console.debug('hasOpen:'+hasOpen);
          if(hasOpen){
            h.classList.add('scrolled-past-header');
          }
            
        
            
        });

        item.addEventListener('mouseleave', function() {
           console.debug('menuitem mouseleave:');
           th.checkMenuOpenAndRemoveClass();
          
        });

      
      });
      */

      
        
    }

    setupMenuObservation() {
        // 延迟执行观察逻辑
        setTimeout(() => {
            const megaMenus = document.querySelectorAll('.mega-menu'); // 选择所有匹配的元素

            console.debug('megaMenus:', megaMenus); // 检查选择到的元素

            megaMenus.forEach(megaMenu => {
                // 开始观察每个目标节点的属性变化
                this.mutationObserver.observe(megaMenu, { attributes: true });
            });
        }, 100); // 延迟100毫秒后执行
    }

   isAnyMenuOpen(){
       const megaMenus = document.querySelectorAll('.mega-menu');
        return Array.from(megaMenus).some(mm => mm.hasAttribute('open'));
    }
    checkMenuOpenAndRemoveClass(isOpen) {
      console.log('params:'+isOpen);
       if(isOpen){
         console.debug('ready add class:');
           this.header.classList.add('scrolled-past-header');
        }else{
         console.debug('ready remove class:');
           //this.header.classList.remove('scrolled-past-header');
         this.onScroll();
        }
    }
    /**
    isMenuOpen() {
      const headerMenus = document.querySelector('.mega-menu');
      headerMenus.forEach(function(item) {
        if(){
          
        }
      });
        return headerMenu.classList.contains('open');
    }
  */

    
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    
    
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
